import { ApiKeys } from '@app/constants/api-keys'
import { IOrganizationType } from '@app/interfaces/organization/organization-type'
import { resolveTParams } from '@app/utils/resolve-params/resolve-params'
import localforage from 'localforage'
import { emptyOrganizationApi } from '.'
import { IRtkResponse } from '../../types'

export const organizationTypeApi = emptyOrganizationApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getOrganizationTypes: build.query<
      IRtkResponse<IOrganizationType[]>,
      URLSearchParams | string
    >({
      query: (args = '') => ({
        url: 'dictionary/api/v1/organization-type',
        method: 'get',
        params: {
          ...resolveTParams(args),
        },
      }),
      transformResponse: (response: IOrganizationType[], meta) => {
        return { response, meta }
      },
      providesTags: (data) =>
        data
          ? [
              ...data.response.map(({ id }) => ({
                type: ApiKeys.organizationType,
                id,
              })),
              { type: ApiKeys.organizationType, id: 'LIST' },
            ]
          : [{ type: ApiKeys.organizationType, id: 'LIST' }],
      async onQueryStarted(args, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          localforage.setItem(ApiKeys.organizationType, data?.response)
        } catch (e) {
          console.error(e)
        }
      },
    }),
    getOrganizationType: build.query<IOrganizationType, number>({
      query: (id) => ({
        url: `dictionary/api/v1/organization-type/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [
        { type: ApiKeys.organizationType, id },
      ],
    }),
  }),
})

const useStateGetOrganizationTypeQuery =
  organizationTypeApi.endpoints.getOrganizationType.useQueryState
const useStateGetOrganizationTypesQuery =
  organizationTypeApi.endpoints.getOrganizationTypes.useQueryState

export const {
  useGetOrganizationTypesQuery,
  useGetOrganizationTypeQuery,
  util,
  usePrefetch,
} = organizationTypeApi

export { useStateGetOrganizationTypeQuery, useStateGetOrganizationTypesQuery }
